import React, { useState, useEffect } from 'react';
import { Form } from 'semantic-ui-react';
import { producaov2 as api } from '../../../../services/apis';
import { isAuthAdmin } from "../../../../services/auth";
import swal from "sweetalert";

import {
    StyledLabel,
    StyledButton,
    ContainerDouble,
    ContainerSingle
} from './styles';

const Formulario = () => {
    const [eventoID, setEventoID] = useState(null);
    const [eventoNome, setEventoNome] = useState(null);
    const [eventoEmail, setEventoEmail] = useState(null);
    const [eventoInicioDia, setEventoInicioDia] = useState(null);
    const [eventoInicioHora, setEventoInicioHora] = useState(null);
    const [eventoFinalDia, setEventoFinalDia] = useState(null);
    const [eventoFinalHora, setEventoFinalHora] = useState(null);
    const [eventoURL, setEventoURL] = useState(null);

    useEffect(async () => {
        loadAuth();

        const url = window.location.href;
        const urlArray = url.split('/');
        const url_params = urlArray[urlArray.length - 1];

        const response = await api.get(`/eventos/${url_params}`);
        setEventoID(response.data.id);
        setEventoNome(response.data.titulo);
        setEventoEmail(response.data.modelo_email);
        setEventoInicioDia(response.data.data_inicio.substr(0, 10));
        setEventoInicioHora(response.data.data_inicio.substr(11, response.data.data_inicio.length));
        setEventoFinalDia(response.data.data_final.substr(0, 10));
        setEventoFinalHora(response.data.data_final.substr(11, response.data.data_final.length));
        setEventoURL(response.data.url_evento);
    }, []);

    const loadAuth = async () => {
        const auth = await isAuthAdmin();

        if (!auth) {
            localStorage.setItem("redirect", `/admin/`);
            window.location.href = "/login";
            return null;
        }
    };

    async function editEvento() {
        const data = {
            id: eventoID,
            titulo: eventoNome,
            data_inicio: `${eventoInicioDia} ${eventoInicioHora}:00`,
            data_final: `${eventoFinalDia} ${eventoFinalHora}:00`,
            url_evento: eventoURL,
            modelo_email: eventoEmail
        }

        await api
            .put(`/admin/eventos/editar`, data)
            .then(res => {
                swal('Dados alterados com sucesso!', 'O evento foi alterado.', 'success');
            })
            .catch(err => {
                console.error(err);
                swal('Erro na alteração!', 'Aconteceu algum erro durante a edição.', 'error');
            });
    }

    function generateURL(evento) {
        const auxArray = evento.split(" ");
        let auxText = "";
        let i;
        for (i = 0; i < auxArray.length; i++) {
            auxText += auxArray[i] + "-";
        }
        const url = auxText.substr(0, auxText.length - 1);
        setEventoURL(url);
    }

    return (
        <Form>
            <Form.Field>
                <StyledLabel>ID do evento</StyledLabel>
                <Form.Input
                    value={eventoID}
                    readonly
                    disabled="disabled"
                />
            </Form.Field>
            <Form.Field>
                <StyledLabel>Título do evento</StyledLabel>
                <Form.Input
                    placeholder='Título do evento'
                    value={eventoNome}
                    onChange={e => {
                        setEventoNome(e.target.value);
                        generateURL(e.target.value);
                    }}
                />
            </Form.Field>
            <Form.Field>
                <StyledLabel>Modelo do e-mail de inscrição</StyledLabel>
                <Form.Input
                    placeholder='Modelo do e-mail'
                    type="number"
                    value={eventoEmail}
                    onChange={e => setEventoEmail(e.target.value)}
                />
            </Form.Field>
            <Form.Field>
                <StyledLabel>Início do evento</StyledLabel>
                <ContainerDouble>
                    <ContainerSingle>
                        <StyledLabel>Dia</StyledLabel>
                        <Form.Input
                            type="date"
                            value={eventoInicioDia}
                            onChange={e => setEventoInicioDia(e.target.value)}
                        />
                    </ContainerSingle>
                    <ContainerSingle>
                        <StyledLabel>Hora</StyledLabel>
                        <Form.Input
                            type="time"
                            value={eventoInicioHora}
                            onChange={e => setEventoInicioHora(e.target.value)}
                        />
                    </ContainerSingle>
                </ContainerDouble>
            </Form.Field>
            <Form.Field>
                <StyledLabel>Fim do evento</StyledLabel>

                <ContainerDouble>
                    <ContainerSingle>
                        <StyledLabel>Dia</StyledLabel>
                        <Form.Input
                            type="date"
                            value={eventoFinalDia}
                            onChange={e => setEventoFinalDia(e.target.value)}
                        />
                    </ContainerSingle>
                    <ContainerSingle>
                        <StyledLabel>Hora</StyledLabel>
                        <Form.Input
                            type="time"
                            value={eventoFinalHora}
                            onChange={e => setEventoFinalHora(e.target.value)}
                        />
                    </ContainerSingle>
                </ContainerDouble>
            </Form.Field>
            <StyledButton onClick={editEvento} >
                <i class="plus icon"></i> Salvar Alterações
            </StyledButton>
        </Form>
    );
}


export default Formulario;
